export const MAX_CARDS_LENGTH = 5;
export const MAX_HAND_CARDS_LENGTH = 2;
export const EXPECTED_FRAMERATE = 30;
